import type * as Types from 'app/types/graphql';

import { VariantPriceSelectFragmentDoc } from '../fragments/variantPrice.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantPriceCreateMutationVariables = Types.Exact<{
  input: Types.CreateVariantPriceInput;
}>;

export type VariantPriceCreateMutationResponse = {
  variantPriceCreate?: Types.Maybe<
    Pick<
      Types.VariantPrice,
      'id' | 'baseID' | 'handle' | 'status' | 'title' | 'redirectURL' | 'sourceProductBaseID'
    >
  >;
};

export const VariantPriceCreateDocument = `
    mutation VariantPriceCreate($input: CreateVariantPriceInput!) {
  variantPriceCreate(input: $input) {
    ...VariantPriceSelect
  }
}
    ${VariantPriceSelectFragmentDoc}`;

export const useVariantPriceCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantPriceCreateMutationResponse,
    TError,
    VariantPriceCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantPriceCreateMutationResponse,
    TError,
    VariantPriceCreateMutationVariables,
    TContext
  >(
    ['VariantPriceCreate'],
    (variables?: VariantPriceCreateMutationVariables) =>
      appFetcher<VariantPriceCreateMutationResponse, VariantPriceCreateMutationVariables>(
        VariantPriceCreateDocument,
        variables,
      )(),
    options,
  );
};

useVariantPriceCreateMutation.getKey = () => ['VariantPriceCreate'];
